import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  GridWithoutBorderHLPure,
  CardCircularProgressBarHLPure,
  // ColumnChartHLPure,
} from "../../pures";
import { HeaderHLPure, CardSwiperHLPure } from "../../pures";
import { ContractBlueIcon, contracts } from "../../../assets/logos/icons";
import { templates } from "../../../assets/logos/icons";
import { questionnaire } from "../../../assets/logos/icons";
import "./digital-contract-dashboard.css";
import { NIL as NIL_UUID } from "uuid";
import { useMediaQuery } from "@material-ui/core";
import { CircularProgressbar } from "react-circular-progressbar";

const DigitalContractDashboardView = (props) => {
  const { t } = useTranslation();
  const { clientCompany, userInformation, percentageProgress } = props;
  const [dataUser, setDataUser] = useState(clientCompany);
  const [selectedValueFilter, setSelectedValue] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  // const [statusContracts, setStatusContracts] = useState();
  // const [contractsForLawyers, setContractsForLawyers] = useState();
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: "",
  });
  const [totalContracts, setTotalContracts] = useState(0)
  const [contractsDelivered, setContractsDelivered] = useState(0)
  const [percentageContractsDelivered, setPercentContractsDelivered] = useState(0)

  //Filter Function, convert to boolean
  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  };
  //Filter Function, get selected value
  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
  };

  //Update state information from grid
  useEffect(() => {
    setDataUser(props.statusContracts);
  }, [props.statusContracts]);

  //Filter Function, filter elements and update grid
  useEffect(() => {
    let usersCopy = [...props.statusContracts];
    let dataUpadate = usersCopy.filter(
      (user) => user.name === selectedValueFilter
    );
    setDataUser(dataUpadate);
  }, [selectedValueFilter]);

  // Search Function, get value search input
  const searchChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };
  //Search Function, search elements and update grid
  useEffect(() => {
    let usersCopy = [...props.statusContracts];
    let dataUpdateFilter =
      selectedValueFilter === NIL_UUID
        ? props.statusContracts
        : usersCopy.filter((client) => client.status === selectedValueFilter);

    let dataUpdateSearch = dataUpdateFilter.filter((client) => {
      return (
        client.clientName.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
      );
    });
    setDataUser(dataUpdateSearch);
  }, [searchValue, selectedValueFilter]);

  useEffect(() => {
    if (!percentageProgress || percentageProgress.length === 0) return
    let totalContracts = (percentageProgress[0].valueChart) ? percentageProgress[0].valueChart : 0
    let percentContractsDelivered = (percentageProgress.length > 1 && percentageProgress[1].valueChart) ? percentageProgress[1].valueChart : 0

    let contractsDelivered = Math.round(percentContractsDelivered)
    setTotalContracts(totalContracts)
    setContractsDelivered(contractsDelivered)
    setPercentContractsDelivered(percentContractsDelivered)
  }, [percentageProgress])

  const mobileResolution = useMediaQuery("(max-width:280px)");
  const mobileResolutionLg = useMediaQuery("(max-width:1360px)");


  return (
    <div className="digitalContractDashboard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
          <>
            {/*Container primera seccion de items, fila*/}
            <Grid
              lg={12}
              md={12}
              xs={12}
              sm={12}
              container
            >
              {/* Container de total de contratos*/}
              <Grid
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="digitalContractDashboard-totalContractGrid"
              >
                <Grid
                  lg={6}
                  md={6}
                  sm={12}
                  xs={12}
                  className="digitalContractDashboard-TotalContract-Right"
                >
                  <img src={ContractBlueIcon} className="digitalContractDashboard-TotalContract-icon" />
                  <label style={{ fontSize: "24px" }}>
                    {`${t("digitalContractDashboard.contracts.total")} ${totalContracts}`}
                  </label>
                </Grid>
                <Grid
                  lg={6}
                  md={6}
                  sm={12}
                  xs={12}
                  className="digitalContractDashboard-TotalContract-Left"
                >
                  <CircularProgressbar
                    value={percentageContractsDelivered}
                    className="digitalContractDashboard-TotalContract-icon"
                  />
                  <label style={{ fontSize: "24px" }}>
                    {`${t("digitalContractDashboard.contracts.delivered")} ${contractsDelivered}%`}
                  </label>
                </Grid>
              </Grid>
              {/*Cards container */}
              <Grid
                lg={12}
                md={12}
                xs={12}
                sm={12}
                className={"digitalContractDashboard-containerCardsGrid"}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className={"digitalContractDashboard-gridContainers"}
                >
                  <Grid
                    item
                    xs={12}
                    className={
                      props.itemsCardsDashboard.length > 2
                        ? "digitalContractDashboard-statusContract"
                        : "digitalContractDashboard-statusContract-oneCard"
                    }
                  >
                    <h2 className="digitalContractDashboard-titleGrid">
                      {t("digitalContractDashboard.countContractStatus")}
                    </h2>
                    <GridWithoutBorderHLPure
                      skip={0}
                      take={5}
                      dataGrid={props.statusContracts}
                      titleRow1={t("digitalContractDashboard.reports.statusTitle")}
                      fieldRow1={"workflowExecutionName"}
                      titleRow2={t("digitalContractDashboard.reports.contractNumber")}
                      fieldRow2={"countWorkflowExecution"}
                      onFilterChange={filterChange}
                      onSelectedItem={setSelectedUser}
                      selectedValueFilter={selectedValueFilter}
                      filter={true}
                      pagination={true}
                      column2Status
                    />
                  </Grid>
                  {/* </Grid> */}
                  {props.disableGridLawyer !== true ? (
                    <Grid
                      item
                      xs={12}
                      className="digitalContractDashboard-lawyer"
                    >
                      <h2 className="digitalContractDashboard-titleGrid">
                        {t("digitalContractDashboard.contractsForLawyers")}
                      </h2>
                      <GridWithoutBorderHLPure
                        skip={0}
                        take={5}
                        dataGrid={props.contractsForLawyers}
                        titleRow1={t("digitalContractDashboard.reports.lawyerTitle")}
                        fieldRow1={"nameLawyer"}
                        titleRow2={t("digitalContractDashboard.reports.contractNumber")}
                        fieldRow2={"countClientContracts"}
                        onFilterChange={filterChange}
                        onSelectedItem={setSelectedUser}
                        selectedValueFilter={selectedValueFilter}
                        filter={true}
                        column2Status
                      />
                    </Grid>
                  ) : null}
                  {props.disabledGridClient !== true ? (
                    <Grid
                      item
                      xs={12}
                      className={
                        props.itemsCardsDashboard.length > 2
                          ? "digitalContractDashboard-client"
                          : "digitalContractDashboard-client-oneCard"
                      }
                    >
                      <h2 className="digitalContractDashboard-titleGrid">
                        {t("digitalContractDashboard.countClientContracts")}
                      </h2>
                      <GridWithoutBorderHLPure
                        skip={0}
                        take={5}
                        dataGrid={props.clientPerApplicant}
                        titleRow1={t("digitalContractDashboard.reports.clientTitle")}
                        fieldRow1={"nameClient"}
                        titleRow2={t("digitalContractDashboard.reports.contractNumber")}
                        fieldRow2={"countClientContracts"}
                        onFilterChange={filterChange}
                        onSelectedItem={setSelectedUser}
                        selectedValueFilter={selectedValueFilter}
                        filter={true}
                        column2Status
                        pagination={true}
                      />
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </>
      )}
    </div>
  );
};

export default DigitalContractDashboardView;
